var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BoxContent"},[_c('div',{staticClass:"boxOne"},[_c('svg-btn',{staticClass:"icon",attrs:{"icon-class":"icon-short-no"}}),_c('span',{staticClass:"font1"},[_vm._v(_vm._s(_vm.$t('model.mtest7')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }